module.exports = __webpack_public_path__ + "img/ozon.1de3a70f.svg";